import { Box } from "@twilio-paste/core/box";
import { Button } from "@twilio-paste/core/button";
import { Heading } from "@twilio-paste/core/heading";
import { HideIcon } from "@twilio-paste/icons/esm/HideIcon";
import { ShowIcon } from "@twilio-paste/icons/esm/ShowIcon";
import React from "react";
import { v4 as uuid } from "uuid";
import { CodeBlock, CodeBlockOverlayShadow } from "../CodeBlock";
import { CopyButton } from "../CopyButton";

const Example: React.FC<{ example: string; description?: string }> = ({ example, description }) => {
    const [viewCode, setViewCode] = React.useState(false);
    const id = uuid();

    const handleToggleCodeEditor = (): void => {
        setViewCode(!viewCode);
    };

    const isSmallCodeVariant = ((example.match(/\n/g) || "").length as number) + 1 <= 3;

    return (
        <Box paddingBottom="space120">
            {description && <div dangerouslySetInnerHTML={{ __html: description! }} />}
            <Heading as="h3" variant="heading30">
                Example:
            </Heading>
            <Box
                backgroundColor="colorBackgroundBodyInverse"
                borderBottomLeftRadius="borderRadius20"
                borderBottomRightRadius="borderRadius20"
                borderColor="colorBorderWeak"
                borderStyle="solid"
                borderWidth="borderWidth20"
                borderTopWidth="borderWidth0"
                fontSize="fontSize20"
                position="relative"
                height={viewCode ? "auto" : "112px"}
                overflow="hidden"
            >
                {isSmallCodeVariant ? null : (
                    <Box position="absolute" top="space40" right="space40" zIndex="zIndex10">
                        <Button
                            variant="secondary"
                            data-testid="viewCode"
                            size="small"
                            onClick={handleToggleCodeEditor}
                            aria-label="View Code"
                            aria-expanded={viewCode}
                            aria-controls={id}
                        >
                            {viewCode ? (
                                <>
                                    <HideIcon decorative />
                                    <span>Hide code</span>
                                </>
                            ) : (
                                <>
                                    <ShowIcon decorative />
                                    <span>View code</span>
                                </>
                            )}
                        </Button>
                    </Box>
                )}
                <CodeBlock>{example}</CodeBlock>
                {isSmallCodeVariant || viewCode ? null : <CodeBlockOverlayShadow />}
                {isSmallCodeVariant || viewCode ? (
                    <Box position="absolute" bottom="space40" right="space40">
                        <CopyButton text={example} />
                    </Box>
                ) : null}
            </Box>
        </Box>
    );
};

export { Example };
